import React, { useState } from "react";
import { Modal, DatePicker, Typography } from "antd";
import moment from "moment";

const { Text } = Typography;

export default function UnfreezeStudentModal({
  visible,
  onCancel,
  onOk,
  lastExpireDate = "",
}) {
  // 默认日期 = 今天
  const [expireDate, setExpireDate] = useState(moment());
  const dateFormat = 'YYYY/MM/DD';
  return (
    <Modal
      title="解冻学员账户"
      visible={visible}
      onCancel={onCancel}
      onOk={() => onOk(expireDate)}
      okText="解冻"
      cancelText="取消"
      width={545}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>

        <Text>
          解冻后此学员可以继续登录其账户，请重新为其设置有效期。
        </Text>
        <div>
          <Text strong><i style={{color: 'red', marginRight: 4}}>*</i>账户有效期至&nbsp;&nbsp;</Text>
          <DatePicker
            style={{ width: 120, marginLeft: 0, marginRight: 8 }}
            value={expireDate}
            format={dateFormat}
            disabledDate={date => date && date < moment().startOf('day')}
            onChange={date => setExpireDate(date)}
          />
          <Text type="secondary">
            其上次被设置的有效期是到 {lastExpireDate}
          </Text>
        </div>

        <Text type="secondary">
          到期后学生账户会被冻结，需要本校区管理员将其重新解冻方可再次登录。
        </Text>

      </div>
    </Modal>
  );
}
